export const userDisconnectedEventName = 'user.disconnected'
export const notificationNewReleaseEventName = 'notification.new-release'
export const commentCreatedEventName = 'comment.created'
export const commentUpdatedEventName = 'comment.updated'
